import Cookies from 'js-cookie';

export const MOCK_SCENARIOS_COOKIE_NAME = 'mockScenarios';

export function setMockScenariosCookieFromQueryParam() {
  const pageParams = new URLSearchParams(window.location.search);
  const scenariosNames = pageParams.get('mockScenarios');
  if (scenariosNames === null) {
    return;
  }
  if (scenariosNames === '') {
    Cookies.remove(MOCK_SCENARIOS_COOKIE_NAME);
  } else {
    Cookies.set(MOCK_SCENARIOS_COOKIE_NAME, scenariosNames);
  }
}
